import React from "react";
import { Link } from "react-router-dom";
import "./Course.css";

const Course = ({ course }) => {
  const { logo, name, total, id } = course;

  return (
    <div className="course mx-md-3  mb-lg-0 mb-3 p-2">
      <img src={logo} alt="" className="img-fluid w-100" />
      <div className="d-flex justify-content-between name-question my-4">
        <button className="btn btn-outline-success">{name}</button>
        <button className="btn btn-outline-secondary">Question: {total}</button>
      </div>

      <div>
        <Link to={`/course/${id}`}>
          <button className="btn btn-info text-white w-100 fw-bold fs-5">
            Quiz Start
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Course;
